import { type SetEventsProps, type AddEventProps, type Event } from 'src/types'

const setEvents = (dispatch: (arg0: SetEventsProps) => void, events: Record<string, Event>) => {
  dispatch({
    type: 'SET_EVENTS',
    events
  })
}

const addEvent = (dispatch: (arg0: AddEventProps) => void, event: Event) => {
  dispatch({
    type: 'ADD_EVENT',
    event
  })
}

export {
  setEvents,
  addEvent
}
